var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"standard-login",class:{ 'transborder-login': _vm.isTransborder === 'true' }},[_c('FormCard',{attrs:{"isTransborderCustomer":_vm.isTransborder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }